import styled from 'styled-components';

export const Row = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    height: ${props => props.height}px;
    width: 100%;
    box-sizing: border-box;
    @media only screen and (max-width: 900px) {
        flex-direction: column;
        padding: 25px 0;
        height: auto;
        margin-bottom: 25px;
    }
    &.mobileVersion {
        flex-direction: column;
        padding: 25px 0;
        height: auto;
        margin-bottom: 25px;
    }
    @media only screen and (min-width: 901px) {
        &:not(.mobileVersion) {
            margin-top: ${props => props.margin}px;
            margin-bottom: ${props => props.margin}px;
            &:last-child {
                margin-bottom: 0;
            }
        }
    }
`;